// extracted by mini-css-extract-plugin
export var copyIcon = "_sr-2";
export var discountCard = "_sr-0";
export var discountCode = "_sr-3";
export var discountContent = "_sr-1";
export var loadingCard = "_sr-4";